import { FC, useState, useRef, useCallback, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppDispatch } from '@/redux/hooks';
import { profileActions } from '@/redux/actions';
import { Header, Sidebar, MenuBurger } from '@/components';
import { useOnClickOutside } from '@/hooks';
import useDevice from '@/hooks/useDevice';

import styles from './BaseLayout.module.sass';
import { RunOutChecks } from '@/pages/AmlCheckDetails/components/RunOutChecks/RunOutChecks';

interface BaseLayoutProps {}

const BaseLayout: FC<BaseLayoutProps> = () => {
  const location = useLocation();
  const { isMobile } = useDevice();
  const dispatch = useAppDispatch();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const menuBurgerRef = useRef<HTMLButtonElement>(null);

  const [isActiveMenu, setIsActiveMenu] = useState<boolean>(false);
  const [isActiveTariffsPanel, setIsActiveTariffsPanel] = useState(false);

  const handleOnToggleMenu = useCallback(
    () => setIsActiveMenu(!isActiveMenu),
    [isActiveMenu],
  );

  const handleOnCloseMenu = useCallback(() => setIsActiveMenu(false), []);

  useOnClickOutside(
    [menuBurgerRef, sidebarRef],
    handleOnCloseMenu,
    undefined,
    [],
  );

  useEffect(() => {
    dispatch(profileActions.getProfileInfo());
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsActiveMenu(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <div className={styles.layout}>
      <Sidebar
        ref={sidebarRef}
        isActive={isActiveMenu}
        onClose={handleOnCloseMenu}
      />
      <main className={styles.main}>
        <Header
          isActiveTariffsPanel={isActiveTariffsPanel}
          onToggleTariffsPanel={setIsActiveTariffsPanel}
        >
          <MenuBurger
            ref={menuBurgerRef}
            isActive={isActiveMenu}
            onClick={handleOnToggleMenu}
          />
        </Header>
        <RunOutChecks onClick={() => setIsActiveTariffsPanel(true)} />
        <Outlet />
      </main>
    </div>
  );
};

export default BaseLayout;
